import React, { useState, useEffect } from 'react';
import { checkJobStatus } from '../services/api';

const JobStatus = ({ jobId, onJobComplete }) => {
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!jobId) return;

    const checkStatus = async () => {
      try {
        const statusData = await checkJobStatus(jobId);
        setStatus(statusData.status);
        
        if (statusData.status === 'completed') {
          onJobComplete();
        }
      } catch (error) {
        setError('Error checking job status');
        console.error(error);
      }
    };

    // Check immediately, then every 5 seconds
    checkStatus();
    const intervalId = setInterval(checkStatus, 5000);

    return () => clearInterval(intervalId);
  }, [jobId, onJobComplete]);

  if (error) {
    return <div className="job-status error">{error}</div>;
  }

  return (
    <div className="job-status">
      <h3>Analysis Status</h3>
      <div className="status-indicator">
        <div className={`status-badge ${status}`}>
          {status === 'processing' ? 'Processing...' : 'Completed'}
        </div>
        <div className="job-id">Job ID: {jobId}</div>
      </div>
      {status === 'processing' && (
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-animation"></div>
          </div>
          <p>Your document is being analyzed. This may take a few minutes.</p>
        </div>
      )}
    </div>
  );
};

export default JobStatus;
